import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["r", "strokeWidth", "strokeColor"],
  _excluded2 = ["tag", "look", "size", "paint", "transform", "selectable", "busy"],
  _excluded3 = ["children"],
  _excluded4 = ["type", "children"],
  _excluded5 = ["children"],
  _excluded6 = ["tag"],
  _excluded7 = ["children"],
  _excluded8 = ["children", "value"],
  _excluded9 = ["blank", "look", "rel", "target"],
  _excluded10 = ["targetId", "placeholder", "formId", "portalId", "onFormSubmitted"],
  _excluded11 = ["onCloseClick", "imageUrl", "open"],
  _excluded12 = ["id", "title", "onFormSubmitted", "formId", "portalId", "targetId"],
  _excluded13 = ["value", "disabled", "placement"],
  _excluded14 = ["commitSame", "flushHistoryOnBlur", "invalid", "onBlur", "onChange", "onCommit", "onFocus", "onKeyDown", "revertOnEscape", "selectAllOnFocus", "value"],
  _excluded15 = ["tag"],
  _excluded16 = ["children"],
  _excluded17 = ["options", "onChange", "name", "value", "disabled"];
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import styled, { keyframes, css } from 'styled-components';
import { forwardRef, useMemo, useCallback, useState, useRef, useEffect, useReducer, createElement } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import Prism, { Token } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
var Medium = 500;
var Bold = 700;
var Tablet = 768;
var MqTablet = "(min-width: ".concat(Tablet, "px)");
var Desktop = 1200;
var MqDesktop = "(min-width: ".concat(Desktop, "px)");
var Mono = "'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace";
var Sans = "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif";
var rotate = keyframes(["100%{transform:rotate(360deg);}"]);
var ReffedSpinner = /*#__PURE__*/forwardRef(function BareSpinner(_ref, ref) {
  var _ref$r = _ref.r,
    r = _ref$r === void 0 ? 6 : _ref$r,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
    _ref$strokeColor = _ref.strokeColor,
    strokeColor = _ref$strokeColor === void 0 ? "#59799C" : _ref$strokeColor,
    props = _objectWithoutProperties(_ref, _excluded);
  var d = 2 * Math.PI * r;
  var size = (r + strokeWidth) * 2;
  return /*#__PURE__*/jsx(_StyledDiv$1, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    $_css: [css(["width:", "px;height:", "px;"], size, size)],
    children: /*#__PURE__*/jsx(_StyledSvg, {
      viewBox: "0 0 ".concat(size, " ").concat(size),
      $_css2: [css(["animation:", " 1s linear infinite;"], rotate)],
      children: /*#__PURE__*/jsx("circle", {
        cx: size / 2,
        cy: size / 2,
        r: r,
        fill: "none",
        strokeWidth: strokeWidth,
        stroke: strokeColor,
        strokeLinecap: "round",
        strokeDasharray: "".concat(0.6 * d, ", ").concat(0.4 * d),
        strokeDashoffset: "0"
      })
    })
  }));
});
var Spinner = styled(ReffedSpinner).withConfig({
  displayName: "Spinner",
  componentId: "sc-1vgk7hu-0"
})([""]);
var _StyledDiv$1 = styled("div").withConfig({
  displayName: "Spinner___StyledDiv",
  componentId: "sc-1vgk7hu-1"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledSvg = styled("svg").withConfig({
  displayName: "Spinner___StyledSvg",
  componentId: "sc-1vgk7hu-2"
})(["", ""], function (p) {
  return p.$_css2;
});
function UnstyledButton(props, ref) {
  var _props$tag = props.tag,
    tag = _props$tag === void 0 ? "button" : _props$tag,
    _props$look = props.look,
    look = _props$look === void 0 ? [] : _props$look,
    size = props.size,
    paint = props.paint,
    transform = props.transform,
    selectable = props.selectable,
    _props$busy = props.busy,
    busy = _props$busy === void 0 ? false : _props$busy,
    rest = _objectWithoutProperties(props, _excluded2);
  var finalLook = [].concat(_toConsumableArray(look), [size, paint, transform]).filter(function (el) {
    return el !== Size.Capybara;
  });
  var children = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      children: rest.children
    }), busy && /*#__PURE__*/jsx(_StyledDiv, {
      children: /*#__PURE__*/jsx(Spinner, {})
    })]
  });
  if (tag === "a") {
    var _ = rest.children,
      linkProps = _objectWithoutProperties(rest, _excluded3);
    return /*#__PURE__*/jsx(_StyledA$1, _objectSpread(_objectSpread({}, linkProps), {}, {
      ref: ref,
      $_css: finalLook,
      children: children
    }));
  }
  if (tag === "button") {
    var _rest$type = rest.type,
      type = _rest$type === void 0 ? "button" : _rest$type,
      _2 = rest.children,
      buttonProps = _objectWithoutProperties(rest, _excluded4);
    return /*#__PURE__*/jsx(_StyledButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
      type: type,
      $_css2: finalLook,
      children: children
    }));
  }
  var __ = rest.children,
    otherProps = _objectWithoutProperties(rest, _excluded5);
  return /*#__PURE__*/jsx(_StyledButton2, _objectSpread(_objectSpread({
    as: tag
  }, otherProps), {}, {
    ref: ref,
    $_css3: finalLook,
    children: children
  }));
}
var ReffedButton = /*#__PURE__*/forwardRef(UnstyledButton);
var Button$1 = styled(ReffedButton).withConfig({
  displayName: "Button",
  componentId: "sc-td6fnt-0"
})(["user-select:", ";"], function (_ref2) {
  var _ref2$selectable = _ref2.selectable,
    selectable = _ref2$selectable === void 0 ? false : _ref2$selectable;
  return selectable ? "auto" : "none";
});
function forge(displayName) {
  var look = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  function Unstyled(_ref3, ref) {
    var tag = _ref3.tag,
      props = _objectWithoutProperties(_ref3, _excluded6);
    return /*#__PURE__*/jsx(Button$1, _objectSpread(_objectSpread({}, props), {}, {
      tag: tag || "button",
      look: look,
      ref: ref
    }));
  }
  var Reffed = /*#__PURE__*/forwardRef(Unstyled);
  return styled(Reffed).withConfig({
    displayName: displayName
  }).withConfig({
    displayName: "Button",
    componentId: "sc-td6fnt-1"
  })([""]);
}
var Size = {
  Mole: css(["--height:32px;--lineHeight:16px;--padding:0 8px;"]),
  Capybara: css(["--fontSize:14px;--height:40px;--lineHeight:22px;--padding:0 16px;--radius:4px;"]),
  Moose: css(["--padding:0 2rem;--height:48px;--fontSize:16px;--lineHeight:24px;"])
};
var Paint = {
  Primary: css(["--bg:#0324ff;--hoverBg:#0d009a;--activeBg:#09006d;--text:#ffffff;--disabledText:rgba(255,255,255,0.5);"]),
  PrimaryOutlined: css(["--text:#0324ff;--hoverText:#0d009a;--activeText:#09006d;"]),
  Secondary: css(["--bg:#efefef;--activeBg:#d8d8d8;--text:#323232;--hoverBg:#e7e7e7;--disabledText:rgba(50,50,50,0.5);"])
};
var Transform = {
  None: css([""]),
  Scale: css(["--transform:scale(1) translateZ(0);--hoverTransform:scale(1.05) translateZ(0);--activeTransform:scale(0.95) translateZ(0);--disabledTransform:var(--transform);"])
};
var ButtonLook = {
  Zero: css(["-webkit-font-smoothing:subpixel-antialiased;align-items:center;appearance:none;backface-visibility:hidden;border:0;box-sizing:border-box;display:inline-flex;font-family:", ";font-weight:", ";justify-content:center;text-align:center;transition:300ms ease-in-out all;white-space:nowrap;"], Sans, Medium),
  Regular: css(["--bg:transparent;--hoverBg:var(--bg);--activeBg:var(--bg);--disabledBg:var(--bg);--text:inherit;--hoverText:var(--text);--activeText:var(--text);--disabledText:var(--text);--textDecoration:none;--hoverTextDecoration:var(--textDecoration);--activeTextDecoration:var(--textDecoration);--disabledTextDecoration:var(--textDecoration);--transform:scale(1) translateZ(0);--hoverTransform:var(--transform);--activeTransform:var(--transform);--disabledTransform:var(--transform);--opacity:1;--disabledOpacity:0.5;", " :visited,&,&[href]{background:var(--bg);border-radius:var(--radius);color:var(--text);font-size:var(--fontSize);height:var(--height);line-height:var(--lineHeight);opacity:var(--opacity);padding:var(--padding);transform:var(--transform);text-decoration:var(--textDecoration);}:focus,:hover{background:var(--hoverBg);color:var(--hoverText);transform:var(--hoverTransform);transition-duration:25ms;text-decoration:var(--hoverTextDecoration);}:active{background:var(--activeBg);color:var(--activeText);transform:var(--activeTransform);text-decoration:var(--activeTextDecoration);}&[disabled]{background:var(--disabledBg);color:var(--disabledText);opacity:var(--disabledOpacity);pointer-events:none;transform:var(--disabledTransform);text-decoration:var(--disabledTextDecoration);}"], Size.Capybara),
  Inherit: css(["background:transparent;border:0;color:inherit;font:inherit;letter-spacing:inherit;text-align:left;"]),
  Outline: css(["border:1px solid currentColor;"])
};
var PrimaryButton = forge("PrimaryButton", [ButtonLook.Zero, ButtonLook.Regular, Paint.Primary, Transform.Scale]);
var SecondaryButton = forge("SecondaryButton", [ButtonLook.Zero, ButtonLook.Regular, Paint.Secondary, Transform.Scale]);
var OutlinedButton = forge("OutlinedButton", [ButtonLook.Zero, ButtonLook.Regular, ButtonLook.Outline, Transform.Scale]);
var LinkButton = forge("LinkButton", [ButtonLook.Inherit, css(["--hoverTextDecoration:underline;"])]);
var _StyledDiv = styled("div").withConfig({
  displayName: "Button___StyledDiv",
  componentId: "sc-td6fnt-2"
})(["margin:0 -0.2em 0 0.75em;"]);
var _StyledA$1 = styled("a").withConfig({
  displayName: "Button___StyledA",
  componentId: "sc-td6fnt-3"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledButton = styled("button").withConfig({
  displayName: "Button___StyledButton",
  componentId: "sc-td6fnt-4"
})(["", ""], function (p) {
  return p.$_css2;
});
var _StyledButton2 = styled("button").withConfig({
  displayName: "Button___StyledButton2",
  componentId: "sc-td6fnt-5"
})(["", ""], function (p) {
  return p.$_css3;
});
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-fyvn49-0"
})(["margin:0 auto;padding:0 32px;@media ", "{max-width:640px;}@media ", "{max-width:1104px;}"], MqTablet, MqDesktop);
function defaultWsNormalizer(s) {
  return s;
}
function tokenize(code) {
  var wsNormalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultWsNormalizer;
  var tokens = Prism.tokenize(wsNormalizer(code), Prism.languages.javascript);
  var lines = [];
  var line = [];
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (!line.length) {
      lines.push(line);
    }
    if (typeof token === "string") {
      var _token$split = token.split(/\n/),
        _token$split2 = _toArray(_token$split),
        tail = _token$split2[0],
        rest = _token$split2.slice(1);
      line.push(tail);
      if (!rest.length) {
        continue;
      }
      line = [];
      for (var j = 0; j < rest.length - 1; j++) {
        lines.push([rest[j]]);
      }
      line.push(rest[rest.length - 1]);
      lines.push(line);
      continue;
    }
    line.push(token);
  }
  return lines;
}
var nw = Prism.plugins.NormalizeWhitespace;
function normalizeWhitespace(code, config) {
  return nw.normalize(code, config);
}
function Renderer(_ref4) {
  var children = _ref4.children;
  if (typeof children === "string") {
    return /*#__PURE__*/jsx("span", {
      children: children
    });
  }
  var content = children.content,
    _children$alias = children.alias,
    alias = _children$alias === void 0 ? "" : _children$alias,
    type = children.type;
  if (typeof content === "string") {
    return /*#__PURE__*/jsx("span", {
      className: "".concat(typeof alias === "string" ? alias : alias.join(" "), " ").concat(type).replace(/^\s|\s$/, ""),
      children: content
    });
  }
  if (content instanceof Token) {
    return /*#__PURE__*/jsx(Renderer, {
      children: children
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: content.map(function (t, i) {
      return /*#__PURE__*/jsx(Renderer, {
        children: t
      }, i);
    })
  });
}
function UnstyledHighlight(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded7);
  var lines = useMemo(function () {
    return tokenize(children, normalizeWhitespace);
  }, [children]);
  return /*#__PURE__*/jsx("pre", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/jsx("div", {
      children: lines.map(function (line, i) {
        return /*#__PURE__*/jsxs("code", {
          children: [/*#__PURE__*/jsx("span", {
            className: "linenumber",
            children: i + 1
          }), /*#__PURE__*/jsxs("span", {
            children: ["\u200C", line.map(function (token, j) {
              return /*#__PURE__*/jsx(Renderer, {
                children: token
              }, "".concat(i, "/").concat(j));
            })]
          })]
        }, i);
      })
    })
  }));
}
var Highlight = styled(UnstyledHighlight).withConfig({
  displayName: "Highlight",
  componentId: "sc-ng4l13-0"
})(["font-size:0.625rem;hyphens:none;letter-spacing:0.02rem;line-height:1.25rem;margin:0;max-height:328px;overflow:auto;padding:0;> div{box-sizing:border-box;min-height:100%;padding:24px 0;position:relative;}> div:after{background-color:#f5f5f5;bottom:0;content:'';left:48px;position:absolute;top:0;width:1px;}@media (min-width:992px){> div:after{left:64px;}}code{display:block;font-family:", ";font-weight:", ";}code > span{display:inline-block;}.linenumber + span{padding:0 24px;}.linenumber{color:#adadad;display:inline-block;min-width:48px;text-align:center;user-select:none;}@media (min-width:992px){font-size:0.875rem;line-height:2rem;max-height:480px;.linenumber{min-width:64px;font-size:0.75rem;line-height:2rem;}}.comment{color:#b6b6b6;}.blockcomment{color:#b6b6b6;}.prolog{color:#999;}.doctype{color:#999;}.cdata{color:#999;}.punctuation{color:#5ac;}.tag{color:#e2777a;}.attrname{color:#e2777a;}.namespace{color:#e2777a;}.deleted{color:#e2777a;}.functionname{color:#9a00fc;}.boolean{color:#0324ff;}.number{color:#0900a2;}.function{color:#9a00fc;}.property{color:#f8c555;}.literal-property{color:#0900a2;}.classname{color:#f8c555;}.constant{color:#f8c555;}.symbol{color:#f8c555;}.selector{color:#cc99cd;}.important{color:#cc99cd;font-weight:bold;}.atrule{color:#cc99cd;}.keyword{color:#9a00fc;}.builtin{color:#cc99cd;}.string{color:#eba51d;}.char{color:#7ec699;}.attrvalue{color:#eba51d;}.regex{color:#7ec699;}.variable{color:#eba51d;}.operator{color:#0900a2;}.spread.operator{color:#eba51d;}.entity{color:#67cdcc;cursor:help;}.url{color:#67cdcc;}.bold{font-weight:bold;}.italic{font-style:italic;}.inserted{color:green;}"], Mono, Medium);
var ReffedLabel = /*#__PURE__*/forwardRef(function BareLabel(_ref6) {
  var children = _ref6.children,
    value = _ref6.value,
    props = _objectWithoutProperties(_ref6, _excluded8);
  return /*#__PURE__*/jsxs("label", _objectSpread(_objectSpread({}, props), {}, {
    children: [!!value && /*#__PURE__*/jsx(LabelText, {
      children: value
    }), children]
  }));
});
var LabelText = styled.div.withConfig({
  displayName: "Label__LabelText",
  componentId: "sc-y35oda-0"
})(["font-size:12px;font-weight:", ";line-height:16px;margin:0 0 8px;transition:200ms cubic-bezier(0,0,0.2,1) 0ms;transition-property:color,transform;white-space:nowrap;"], Medium);
var Label = styled(ReffedLabel).withConfig({
  displayName: "Label",
  componentId: "sc-y35oda-1"
})(["display:block;margin:0;"]);
var LinkLook = {
  Inherit: css(["&,:link,:hover,:focus,:visited,:active{color:inherit;text-decoration:inherit;}"]),
  Basic: css(["--color:inherit;--activeColor:var(--color);--hoverColor:var(--color);--textDecoration:inherit;--activeTextDecoration:var(--textDecoration);--hoverTextDecoration:underline;&,:link,:visited{color:var(--color);text-decoration:var(--textDecoration);}:active{color:var(--activeColor);text-decoration:var(--activeTextDecoration);}:hover,:focus{color:var(--hoverColor);text-decoration:var(--hoverTextDecoration);}"])
};
var UnstyledLink = /*#__PURE__*/forwardRef(function UnstyledLink2(_ref7, ref) {
  var _ref7$blank = _ref7.blank,
    blank = _ref7$blank === void 0 ? false : _ref7$blank,
    _ref7$look = _ref7.look,
    look = _ref7$look === void 0 ? [] : _ref7$look,
    rel = _ref7.rel,
    target = _ref7.target,
    props = _objectWithoutProperties(_ref7, _excluded9);
  return /*#__PURE__*/jsx(_StyledA, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    rel: blank ? "noopener noreferrer" : rel,
    target: blank ? "_blank" : target,
    $_css: look
  }));
});
var Link = styled(UnstyledLink).withConfig({
  displayName: "Link",
  componentId: "sc-19hj9ns-0"
})([""]);
var _StyledA = styled("a").withConfig({
  displayName: "Link___StyledA",
  componentId: "sc-19hj9ns-1"
})(["", ""], function (p) {
  return p.$_css;
});
function useRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useCallback(function (el) {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      if (!ref) {
        continue;
      }
      if (typeof ref === "function") {
        ref(el);
        continue;
      }
      ref.current = el;
    }
  }, [].concat(refs));
}
var isSSR = typeof IntersectionObserver === "undefined";
function useInViewport(ref) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    target = _useState2[0],
    setTarget = _useState2[1];
  var targetRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inViewport = _useState4[0],
    setInViewport = _useState4[1];
  var observerRef = useRef(isSSR ? void 0 : new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === targetRef.current) {
        setInViewport(entry.isIntersecting);
      }
    });
  }));
  useEffect(function () {
    var observer = observerRef.current;
    targetRef.current = target;
    if (target) {
      observer === null || observer === void 0 ? void 0 : observer.observe(target);
    } else {
      setInViewport(false);
    }
    return function () {
      if (target) {
        observer === null || observer === void 0 ? void 0 : observer.unobserve(target);
      }
    };
  }, [target]);
  useEffect(function () {
    var observer = observerRef.current;
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, []);
  useEffect(function () {
    if (isSSR) {
      setInViewport(true);
    }
  }, []);
  var attach = useRefs(setTarget, ref);
  return [attach, inViewport];
}
var W = typeof window === "undefined" ? void 0 : window;
var D = typeof document === "undefined" ? void 0 : document;
function injectHubSpotScript() {
  return _injectHubSpotScript.apply(this, arguments);
}
function _injectHubSpotScript() {
  _injectHubSpotScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return new Promise(function (resolve, reject) {
            if (W !== null && W !== void 0 && W.hbspt) {
              return void resolve();
            }
            if (!D) {
              return void reject(new Error("No DOM"));
            }
            var script = document.createElement("script");
            script.src = "//js.hsforms.net/forms/v2.js";
            script.async = true;
            script.onload = function () {
              resolve();
              if (D) {
                D.body.removeChild(script);
              }
            };
            script.onerror = function (e) {
              reject(e);
            };
            D.body.appendChild(script);
          });
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _injectHubSpotScript.apply(this, arguments);
}
function injectHubSpotForm(_x, _x2, _x3, _x4) {
  return _injectHubSpotForm.apply(this, arguments);
}
function _injectHubSpotForm() {
  _injectHubSpotForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(formId, portalId, target, onFormSubmitted) {
    var _ref25,
      signal,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _ref25 = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {}, signal = _ref25.signal;
          _context3.prev = 1;
          _context3.next = 4;
          return injectHubSpotScript();
        case 4:
          if (!(signal !== null && signal !== void 0 && signal.aborted)) {
            _context3.next = 6;
            break;
          }
          return _context3.abrupt("return");
        case 6:
          if (W) {
            W.jQuery = W.jQuery || function () {};
          }
          if (W !== null && W !== void 0 && W.hbspt) {
            W.hbspt.forms.create({
              cssClass: "root",
              errorClass: "invalid",
              errorMessageClass: "errors",
              formId: formId,
              onFormSubmitted: onFormSubmitted,
              portalId: portalId,
              submitButtonClass: "submitInput",
              target: target
            });
          }
          _context3.next = 12;
          break;
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](1);
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 10]]);
  }));
  return _injectHubSpotForm.apply(this, arguments);
}
function Placeholder() {
  return /*#__PURE__*/jsxs("form", {
    className: "root hs-form",
    children: [/*#__PURE__*/jsx("div", {
      className: "field",
      children: /*#__PURE__*/jsx("div", {
        className: "input",
        children: /*#__PURE__*/jsx("input", {
          className: "hs-input",
          type: "email",
          name: "email",
          required: true,
          placeholder: "Enter your email",
          value: "",
          autoComplete: "email",
          readOnly: true
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "hs_submit hs-submit",
      children: /*#__PURE__*/jsx("div", {
        className: "actions",
        children: /*#__PURE__*/jsx("input", {
          type: "submit",
          value: "Subscribe",
          className: "submitInput",
          disabled: true
        })
      })
    })]
  });
}
function BareHubSpotFormContainer(_ref8, ref) {
  var _ref8$targetId = _ref8.targetId,
    targetId = _ref8$targetId === void 0 ? "hbf" : _ref8$targetId,
    _ref8$placeholder = _ref8.placeholder,
    placeholder = _ref8$placeholder === void 0 ? false : _ref8$placeholder,
    formId = _ref8.formId,
    portalId = _ref8.portalId,
    onFormSubmitted = _ref8.onFormSubmitted,
    props = _objectWithoutProperties(_ref8, _excluded10);
  var _useInViewport = useInViewport(ref),
    _useInViewport2 = _slicedToArray(_useInViewport, 2),
    attach = _useInViewport2[0],
    inViewport = _useInViewport2[1];
  var seenRef = useRef(false);
  var _useReducer = useReducer(function (x) {
      return x + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    optionsKey = _useReducer2[0],
    invalidate = _useReducer2[1];
  var optionsRef = useRef({
    formId: formId,
    portalId: portalId,
    targetId: targetId,
    onFormSubmitted: onFormSubmitted
  });
  useEffect(function () {
    optionsRef.current = {
      formId: formId,
      portalId: portalId,
      targetId: targetId,
      onFormSubmitted: onFormSubmitted
    };
    invalidate();
  }, [formId, portalId, targetId, onFormSubmitted]);
  useEffect(function () {
    var mounted = true;
    if (!seenRef.current) {
      return function () {
        mounted = false;
      };
    }
    var opts = optionsRef.current;
    var abortController = new AbortController();
    function inject() {
      return _inject.apply(this, arguments);
    }
    function _inject() {
      _inject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return injectHubSpotForm(opts.formId, opts.portalId, "#".concat(opts.targetId), function () {
                var _opts$onFormSubmitted;
                (_opts$onFormSubmitted = opts.onFormSubmitted) === null || _opts$onFormSubmitted === void 0 ? void 0 : _opts$onFormSubmitted.call(opts, mounted);
                if (mounted) {
                  invalidate();
                }
              }, {
                signal: abortController.signal
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _inject.apply(this, arguments);
    }
    inject();
    return function () {
      abortController.abort();
      mounted = false;
    };
  }, [optionsKey]);
  useEffect(function () {
    if (!inViewport || seenRef.current) {
      return;
    }
    seenRef.current = true;
    invalidate();
  }, [inViewport]);
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    id: targetId,
    ref: attach,
    children: placeholder && /*#__PURE__*/jsx(Placeholder, {})
  }));
}
var ReffedHubSpotFormContainer = /*#__PURE__*/forwardRef(BareHubSpotFormContainer);
var HubSpotFormContainer = styled(ReffedHubSpotFormContainer).withConfig({
  displayName: "HubSpotFormContainer",
  componentId: "sc-13jnlbi-0"
})(["&,.root{height:136px;}.field > label{display:none;}.field{flex-grow:1;margin-bottom:24px;}.submitInput,.input,.hs-input,.field,.actions,.hs-submit{height:56px;}.title{font-weight:700;letter-spacing:1px;margin-bottom:24px;text-transform:uppercase;}.hs-input{appearance:none;border:1px solid #efefef;border-radius:4px;box-sizing:border-box;color:#323232;outline:0;padding:0 16px;transition:200ms border-color;width:100%;}.hs-input:focus{border-color:#0324ff;}.hs-input::placeholder{color:#cdcdcd;}.invalid{border-color:#ff5c00;}.errors{display:none !important;}.submitInput{appearance:none;background-color:#efefef;border:0;border-radius:4px;color:#323232;font-weight:500;outline:0;padding:0;transform:translateZ(0) scale(1);transition:200ms;transition-property:background-color,transform;width:100%;}.submitInput:hover,.submitInput:focus{background-color:#e7e7e7;transform:translateZ(0) scale(1.05);}.submitInput:active{background-color:#d8d8d8;transform:translateZ(0) scale(0.95);transition-duration:10ms;transition-timing-function:ease-out;}@media ", "{&,.root{height:56px;}.root{display:flex;}.field{margin-bottom:0;margin-right:24px;}.submitInput{padding:0 40px;width:auto;}.submitInput,.input,.hs-input,.field,.actions,.hs-submit{height:100%;}}@media ", "{&,.root{height:2.5rem;}.root{width:29.5rem;}}"], MqTablet, MqDesktop);
function useGlobalKeyDownEffect(onKeyDown) {
  var onKeyDownRef = useRef(onKeyDown);
  useEffect(function () {
    onKeyDownRef.current = onKeyDown;
  }, [onKeyDown]);
  useEffect(function () {
    function onKeyDown2(e) {
      onKeyDownRef.current(e);
    }
    window.addEventListener("keydown", onKeyDown2);
    return function () {
      window.removeEventListener("keydown", onKeyDown2);
    };
  }, []);
}
function useOnMouseDownOutsideEffect(callback, ref) {
  var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    isInside = _ref9.isInside;
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    target = _useState6[0],
    setTarget = _useState6[1];
  var callbackRef = useRef(callback);
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    if (!target) {
      return function () {};
    }
    function onInnerMouseDown(e) {
      if (e.target instanceof Element && (target !== null && target !== void 0 && target.contains(e.target) || isInside !== null && isInside !== void 0 && isInside(target, e.target))) {
        return;
      }
      callbackRef.current();
    }
    window.addEventListener("mousedown", onInnerMouseDown);
    return function () {
      window.removeEventListener("mousedown", onInnerMouseDown);
    };
  }, [target]);
  return useRefs(setTarget, ref);
}
var ReffedNewsletterConfirmation = /*#__PURE__*/forwardRef(function BareNewsletterConfirmation(_ref10, ref) {
  var onCloseClick = _ref10.onCloseClick,
    imageUrl = _ref10.imageUrl,
    open = _ref10.open,
    props = _objectWithoutProperties(_ref10, _excluded11);
  useGlobalKeyDownEffect(function (_ref11) {
    var key = _ref11.key;
    if (key === "Escape") {
      onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
    }
  });
  var attach = useOnMouseDownOutsideEffect(function () {
    onCloseClick === null || onCloseClick === void 0 ? void 0 : onCloseClick();
  }, ref);
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: attach,
    children: [/*#__PURE__*/jsx("button", {
      type: "button",
      onClick: onCloseClick,
      children: /*#__PURE__*/jsx("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/jsx("path", {
          d: "M12 12L23 1 12 12 1 1l11 11zm0 0L1 23l11-11 11 11-11-11z",
          stroke: "#000",
          strokeWidth: "2",
          fill: "none",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    }), /*#__PURE__*/jsxs(Container, {
      children: [imageUrl && /*#__PURE__*/jsx("img", {
        src: imageUrl,
        alt: ""
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("h2", {
          children: "Thank you"
        }), /*#__PURE__*/jsx("p", {
          children: "Your subscription has been confirmed. You've been added to our list, and the next Packet Switch newsletter will be on its way to you soon."
        })]
      })]
    })]
  }));
});
var NewsletterConfirmation = styled(ReffedNewsletterConfirmation).withConfig({
  displayName: "NewsletterConfirmation",
  componentId: "sc-1h7ah0k-0"
})(["background-color:white;bottom:0;box-shadow:0 0 15px rgba(0,0,0,0.1);color:#323232;left:0;opacity:0;padding:90px 0;pointer-events:none;position:fixed;transform:translateY(16px);transition:300ms;transition-delay:200ms,0s,0s;transition-property:visibility,opacity,transform;visibility:hidden;width:100%;", " button{appearance:none;background-color:transparent;border:0;box-shadow:none;height:32px;outline:0;padding:8px;position:absolute;right:16px;top:16px;width:32px;}h2{color:inherit;font-size:32px;font-weight:400;line-height:1;margin:0;}p{color:#a3a3a3;font-size:16px;line-height:30px;margin:16px 0 0;}img{display:none;}@media ", "{h2{font-size:40px;}p{font-size:18px;width:575px;}}@media ", "{img{display:block;flex-shrink:0;height:179px;margin-right:80px;width:340px;}", "{align-items:center;display:flex;}}"], function (_ref12) {
  var open = _ref12.open;
  return !!open && css(["opacity:1;pointer-events:auto;transform:translateY(0);transition-delay:0s,0s,0s;visibility:visible;"]);
}, MqTablet, MqDesktop, Container);
var ReffedNewsletterForm = /*#__PURE__*/forwardRef(function UnstyledNewsletterForm(_ref13, ref) {
  var _ref13$id = _ref13.id,
    id = _ref13$id === void 0 ? "newsletter" : _ref13$id,
    _ref13$title = _ref13.title,
    title = _ref13$title === void 0 ? "Subscribe to our newsletter" : _ref13$title,
    onFormSubmitted = _ref13.onFormSubmitted,
    formId = _ref13.formId,
    portalId = _ref13.portalId,
    targetId = _ref13.targetId,
    props = _objectWithoutProperties(_ref13, _excluded12);
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    id: id,
    ref: ref,
    children: [/*#__PURE__*/jsx("div", {
      children: title
    }), /*#__PURE__*/jsx(HubSpotFormContainer, {
      formId: formId,
      onFormSubmitted: onFormSubmitted,
      placeholder: true,
      portalId: portalId,
      targetId: targetId
    })]
  }));
});
var NewsletterForm = styled(ReffedNewsletterForm).withConfig({
  displayName: "NewsletterForm",
  componentId: "sc-1vrdh5f-0"
})(["font-size:16px;padding:1rem 0 56px;> div:first-child{font-weight:", ";letter-spacing:1px;margin-bottom:24px;text-transform:uppercase;}@media ", "{padding:0.5rem 0 32px;}@media ", "{font-size:14px;padding:4rem 0 5rem;}"], Bold, MqTablet, MqDesktop);
var Placement = {
  Top: css(["left:50%;top:auto;bottom:calc(100% + 8px);right:auto;transform:translateX(-50%);"]),
  Bottom: css(["left:50%;top:calc(100% + 8px);bottom:auto;right:auto;transform:translateX(-50%);"])
};
var Parent = styled.div.withConfig({
  displayName: "Tooltip__Parent",
  componentId: "sc-nig6ys-0"
})([""]);
function UnstyledTooltip(_ref14) {
  var value = _ref14.value,
    disabled = _ref14.disabled,
    placement = _ref14.placement,
    props = _objectWithoutProperties(_ref14, _excluded13);
  return /*#__PURE__*/jsx("div", _objectSpread({}, props));
}
var Tooltip = styled(UnstyledTooltip).withConfig({
  displayName: "Tooltip",
  componentId: "sc-nig6ys-1"
})(["", ""], function (_ref15) {
  var value = _ref15.value,
    disabled = _ref15.disabled,
    _ref15$placement = _ref15.placement,
    placement = _ref15$placement === void 0 ? Placement.Top : _ref15$placement;
  return !!value && !disabled && css(["position:relative;display:inline-block;line-height:1;::after{content:'", "';visibility:hidden;opacity:0;transition:0s all;position:absolute;background-color:#323232;border-radius:2px;color:white;font-size:12px;line-height:16px;padding:2px 6px;white-space:nowrap;z-index:1;text-align:center;", ";}", ":hover &::after,:hover::after{transition-delay:0.5s;visibility:visible;opacity:1;}"], value, placement, Parent);
});
var BareTextField = function BareTextField(_ref16, ref) {
  var _ref16$commitSame = _ref16.commitSame,
    commitSame = _ref16$commitSame === void 0 ? false : _ref16$commitSame,
    _ref16$flushHistoryOn = _ref16.flushHistoryOnBlur,
    flushHistoryOnBlur = _ref16$flushHistoryOn === void 0 ? false : _ref16$flushHistoryOn,
    invalid = _ref16.invalid,
    onBlurProp = _ref16.onBlur,
    onChangeProp = _ref16.onChange,
    onCommitProp = _ref16.onCommit,
    onFocusProp = _ref16.onFocus,
    onKeyDownProp = _ref16.onKeyDown,
    _ref16$revertOnEscape = _ref16.revertOnEscape,
    revertOnEscape = _ref16$revertOnEscape === void 0 ? false : _ref16$revertOnEscape,
    _ref16$selectAllOnFoc = _ref16.selectAllOnFocus,
    selectAllOnFocus = _ref16$selectAllOnFoc === void 0 ? false : _ref16$selectAllOnFoc,
    _ref16$value = _ref16.value,
    valueProp = _ref16$value === void 0 ? "" : _ref16$value,
    props = _objectWithoutProperties(_ref16, _excluded14);
  var _props$tag2 = props.tag,
    tag = _props$tag2 === void 0 ? "input" : _props$tag2,
    rest = _objectWithoutProperties(props, _excluded15);
  var _useState7 = useState(valueProp),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];
  useEffect(function () {
    setValue(valueProp);
  }, [valueProp]);
  var _useReducer3 = useReducer(function (x) {
      return x + 1;
    }, 0),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    cacheKey = _useReducer4[0],
    invalidate = _useReducer4[1];
  var commitValueRef = useRef(valueProp);
  var revertToValueRef = useRef(valueProp);
  function onCommit(val) {
    if (!commitSame && commitValueRef.current === val) {
      return;
    }
    commitValueRef.current = value;
    onCommitProp === null || onCommitProp === void 0 ? void 0 : onCommitProp(value);
  }
  var onBlur = function onBlur(e) {
    if (flushHistoryOnBlur) {
      invalidate();
    }
    onCommit(value);
    var blur = onBlurProp;
    blur === null || blur === void 0 ? void 0 : blur(e);
  };
  var onChange = function onChange(e) {
    setValue(e.target.value);
    var change = onChangeProp;
    change === null || change === void 0 ? void 0 : change(e);
  };
  var onFocus = function onFocus(e) {
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
      if (selectAllOnFocus) {
        e.target.select();
      }
    }
    revertToValueRef.current = value;
    var focus = onFocusProp;
    focus === null || focus === void 0 ? void 0 : focus(e);
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.key === "Enter" && e.target instanceof HTMLInputElement) {
      onCommit(value);
    }
    if (revertOnEscape && e.key === "Escape") {
      setValue(revertToValueRef.current);
    }
    var keyDown = onKeyDownProp;
    keyDown === null || keyDown === void 0 ? void 0 : keyDown(e);
  };
  if (tag === "textarea") {
    var taRest = _objectSpread(_objectSpread({}, rest), {}, {
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      onKeyDown: onKeyDown,
      value: value
    });
    return /*#__PURE__*/createElement("textarea", _objectSpread(_objectSpread({}, taRest), {}, {
      key: cacheKey,
      ref: ref
    }));
  }
  var inputRest = _objectSpread(_objectSpread({}, rest), {}, {
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    value: value
  });
  return /*#__PURE__*/createElement("input", _objectSpread(_objectSpread({}, inputRest), {}, {
    key: cacheKey,
    ref: ref
  }));
};
var ReffedTextField = /*#__PURE__*/forwardRef(BareTextField);
var TextField = styled(ReffedTextField).withConfig({
  displayName: "TextField",
  componentId: "sc-19bcysf-0"
})(["appearance:none;backface-visibility:hidden;background-color:white;border-radius:4px;border:1px solid #efefef;box-shadow:none;box-sizing:border-box;color:#323232;display:block;font-size:16px;height:40px;line-height:1;outline:none;padding:0 16px;width:100%;textarea&{resize:vertical;padding-top:0.5em;padding-bottom:0.5em;}:focus{border-color:#0324ff;box-shadow:none;outline:none;}::placeholder{color:#cdcdcd;}", " :disabled{opacity:0.5;cursor:not-allowed;background-color:#efefef;border-color:#efefef;color:#32323280;}&[type='number']{appearance:textfield;}&[type='number']::-webkit-inner-spin-button,&[type='number']::-webkit-outer-spin-button{appearance:none;margin:0;}"], function (_ref17) {
  var _ref17$invalid = _ref17.invalid,
    invalid = _ref17$invalid === void 0 ? false : _ref17$invalid;
  return invalid && css(["border-color:#ff5c00;"]);
});
var ReffedHint = /*#__PURE__*/forwardRef(function BareHint(_ref18, ref) {
  var children = _ref18.children,
    props = _objectWithoutProperties(_ref18, _excluded16);
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    children: ["\u200C", children]
  }));
});
var Hint = styled(ReffedHint).withConfig({
  displayName: "Hint",
  componentId: "sc-pqlons-0"
})(["font-size:12px;line-height:1.5em;margin-top:6px;position:absolute;"]);
var ImageChecked = "data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%3Cg%20stroke-width%3D%221.5%22%3E%20%20%20%20%20%20%3Cpath%20stroke%3D%22%23FFF%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20d%3D%22M4.094%208.562l2.2%202.39%205.657-5.657%22%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var ReffedCheckbox = /*#__PURE__*/forwardRef(function BareCheckbox(props, ref) {
  return /*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, props), {}, {
    type: "checkbox",
    ref: ref
  }));
});
var Checkbox = styled(ReffedCheckbox).withConfig({
  displayName: "Checkbox",
  componentId: "sc-i0a756-0"
})(["appearance:none;background-color:transparent;border:2px solid #cdcdcd;border-radius:2px;cursor:pointer;flex-shrink:0;height:16px;margin-right:0.5em;overflow:hidden;position:relative;top:0;width:16px;transition:200ms ease-in-out;transition-property:background-color,border-color;:focus{outline:none;}::after{background:url(", ") no-repeat;border-radius:2px;bottom:0;content:' ';display:block;left:0;opacity:0;position:absolute;right:0;top:0;transform:scale(0.1);transition:200ms ease-in-out;transition-property:transform,opacity;}", ""], ImageChecked, function (_ref19) {
  var _ref19$checked = _ref19.checked,
    checked = _ref19$checked === void 0 ? false : _ref19$checked;
  return !!checked && css(["background-color:#0324ff;border-color:#0324ff;::after{opacity:1;transform:scale(1);}"]);
});
var Option = styled.span.withConfig({
  displayName: "Radio__Option",
  componentId: "sc-1hogh96-0"
})(["font-weight:", ";opacity:0;position:absolute;transition:var(--speed) ease-in-out opacity;", ""], Medium, function (_ref20) {
  var _ref20$$active = _ref20.$active,
    $active = _ref20$$active === void 0 ? false : _ref20$$active;
  return $active && css(["opacity:1;"]);
});
var Button = styled.button.withConfig({
  displayName: "Radio__Button",
  componentId: "sc-1hogh96-1"
})(["appearance:none;backface-visibility:hidden;background:transparent;border:0;font:inherit;height:100%;transition:var(--speed) ease-in-out opacity;user-select:none;width:100%;opacity:0;", ""], function (_ref21) {
  var _ref21$$active = _ref21.$active,
    $active = _ref21$$active === void 0 ? false : _ref21$$active;
  return $active && css(["cursor:pointer;opacity:0.5;:hover{opacity:1;}"]);
});
var Inner = styled.div.withConfig({
  displayName: "Radio__Inner",
  componentId: "sc-1hogh96-2"
})(["position:relative;height:64px;> div{border-radius:8px;box-shadow:0 0 6px 0 rgba(0,0,0,0.1);pointer-events:none;user-select:none;background:white;position:absolute;left:0;top:0;transition:var(--speed) ease-in-out transform;z-index:1;}> div,li{display:flex;align-items:center;justify-content:center;height:100%;}ul{display:flex;list-style:none;margin:0;padding:0;height:100%;}li input{display:none;}"]);
var ReffedRadio = /*#__PURE__*/forwardRef(function BareRadio(_ref22, ref) {
  var _ref22$options = _ref22.options,
    options = _ref22$options === void 0 ? [] : _ref22$options,
    onChange = _ref22.onChange,
    name = _ref22.name,
    _ref22$value = _ref22.value,
    value = _ref22$value === void 0 ? options[0] || null : _ref22$value,
    _ref22$disabled = _ref22.disabled,
    disabled = _ref22$disabled === void 0 ? false : _ref22$disabled,
    props = _objectWithoutProperties(_ref22, _excluded17);
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    children: /*#__PURE__*/jsxs(Inner, {
      children: [/*#__PURE__*/jsxs("div", {
        style: {
          transform: "translateX(".concat(100 * (value ? options.indexOf(value) : 0), "%)")
        },
        children: ["\u200C", options.map(function (option) {
          return /*#__PURE__*/jsx(Option, {
            $active: option === value,
            children: option
          }, option);
        })]
      }), /*#__PURE__*/jsx("ul", {
        children: options.map(function (option, i) {
          return /*#__PURE__*/jsxs("li", {
            children: [/*#__PURE__*/jsx("input", {
              type: "radio",
              name: name,
              value: option,
              checked: option === value,
              disabled: disabled
            }), /*#__PURE__*/jsx(Button, {
              type: "button",
              onClick: function onClick() {
                onChange === null || onChange === void 0 ? void 0 : onChange(option);
              },
              $active: option !== value,
              children: option
            })]
          }, option);
        })
      })]
    })
  }));
});
var Radio = styled(ReffedRadio).withConfig({
  displayName: "Radio",
  componentId: "sc-1hogh96-3"
})(["--speed:350ms;background-color:#f1f1f1;border-radius:4px;box-sizing:border-box;letter-spacing:0;padding:16px;text-align:center;width:100%;li{flex-basis:", ";}", " > div{width:", ";}"], function (_ref23) {
  var _ref23$options = _ref23.options,
    options = _ref23$options === void 0 ? [] : _ref23$options;
  return "".concat(100 / options.length, "%");
}, Inner, function (_ref24) {
  var _ref24$options = _ref24.options,
    options = _ref24$options === void 0 ? [] : _ref24$options;
  return "".concat(100 / options.length, "%");
});
export { Button$1 as Button, ButtonLook, Paint as ButtonPaint, Size as ButtonSize, Transform as ButtonTransform, Checkbox, Container, Highlight, Hint, HubSpotFormContainer, Label, Link, LinkButton, LinkLook, NewsletterConfirmation, NewsletterForm, OutlinedButton, PrimaryButton, Radio, SecondaryButton, TextField, Tooltip, Parent as TooltipParent, Placement as TooltipPlacement, forge as forgeButton };